// extracted by mini-css-extract-plugin
export var chevronIcon = "_3w-2";
export var teamName = "_3w-1";
export var teamSwitcherButton = "_3w-0";